// extracted by mini-css-extract-plugin
var _1 = "imagePager-module__imagePager___K6jjc";
var _2 = "imagePager-module__imagePagerImage___f35T9";
export { _1 as "imagePager", _2 as "imagePagerImage" }
